import { createBrowserRouter } from "react-router-dom"
import FlowEditorScreen from "./FlowEditorScreen/FlowEditorScreen"

export const router = createBrowserRouter([{ path: "/", element: <FlowEditorScreen /> }])
